module.exports = "../dist/img/upper-banner-32.35ad.jpg";